import { Reason } from '@/domain/entities/MasterData'
import { container } from 'tsyringe'
import Vue from 'vue'
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators'
import { MasterDataPresenter } from '../presenters/MasterDataPresenter'
import store from '../store'

export interface MasterDataState {
  reasons?: Reason[]
  isLoadingReasons: boolean
}

@Module({
  name: 'MasterData',
  namespaced: true,
  dynamic: true,
  store,
})
class MasterDataController extends VuexModule implements MasterDataState {
  private presenter: MasterDataPresenter = container.resolve(MasterDataPresenter)
  public reasons: Reason[] = []
  public isLoadingReasons = false

  @Action({ rawError: true })
  public async getReasons(): Promise<void> {
    this.setIsLoadingReasons(true)
    return this.presenter
      .getReasons()
      .then(resp => {
        this.setReasons(resp.reasons || [])
        this.setIsLoadingReasons(false)
      })
      .catch(err => {
        this.setIsLoadingReasons(false)
        Vue.notify({
          title: 'Fetch Reason Failed',
          text:
            err?.status === 400 || err?.status === 422
              ? err?.error?.message?.en || 'Something went wrong'
              : 'Something Went Wrong',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Mutation
  private setReasons(reasons: Reason[]): void {
    this.reasons = reasons
  }

  @Mutation
  private setIsLoadingReasons(isLoading: boolean): void {
    this.isLoadingReasons = isLoading
  }
}

export default getModule(MasterDataController)
